import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { TemplateDesignElement } from '../../design-element';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  ConfirmationType,
  MassNotificationTemplate,
  MessageSettings
} from 'src/app/modules/communications/store/communications';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';
import { TextElementSettings } from '../text-control/text-control-model';
import produce from 'immer';

@Component({
    selector: 'app-push-text-control',
    templateUrl: './push-text-control.component.html',
    styleUrls: ['./push-text-control.component.scss'],
    standalone: false
})
export class PushTextControlComponent implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() messageSettings?: MessageSettings;
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this._culture = value;
    if (!this.editMode && !!value) {
      this.render();
    }
  }
  _culture: string;
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();

  editMode: boolean;
  showText: boolean = false;
  textValue: string;
  textOrPlaceHolder: string;

  constructor(private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  private getEditPlaceHolder(): string {
    if (!!this.templateDesignerService.staticTextTranslations?.['EDIT-TEXT-PLACEHOLDER'][this._culture]) {
      var defaultText = this.templateDesignerService.staticTextTranslations['EDIT-TEXT-PLACEHOLDER'][this._culture];
      return `<div style="font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 400; color: #000000">${defaultText}</div>`;
    }

    return null;
  }

  onEditClick(): void {
    this.showText = true;
  }

  onTextChanged(): void {
    const control = produce(this.control, draftState => {
      if (!!!draftState.settings) {
        draftState.settings = {
          richText: {}
        } as TextElementSettings;
      }
      if (!draftState.settings.richText) {
        draftState.settings.richText = {};
      }
      draftState.settings.richText[this._culture] = this.textValue;
    });

    this.textOrPlaceHolder = this.textValue;
    this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
  }

  loadSettings(): void {
    this.showText = false;
    this.editMode = true;
    this.loadData();
  }

  private loadData(): void {
    const settings: TextElementSettings = this.control?.settings;

    let textValue = this.templateDesignerService.getTranslateText(settings?.richText, this._culture);
    if (!!textValue) {
      this.textValue = textValue;
      this.textOrPlaceHolder = this.textValue;
    } else {
      this.textOrPlaceHolder = this.getEditPlaceHolder();
    }
  }

  saveSettings(): boolean {
    return true;
  }

  render(): void {
    this.editMode = false;
    this.loadData();
  }

  edit(): void {
    this.onEditClick();
  }

  updateText(text: string): void {
    this.showText = false;
    const control = produce(this.control, draftState => {
      if (!!!draftState.settings) {
        draftState.settings = {
          richText: {}
        } as TextElementSettings;
      }
      if (!draftState.settings.richText) {
        draftState.settings.richText = {};
      }
      draftState.settings.richText[this._culture] = text;
    });

    this.control = control;

    this.textValue = text;
    this.textOrPlaceHolder = this.textValue;
    this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
  }

  cancelText(): void {
    this.showText = false;
  }

  setRuntimeData(data: any): void {}
}
